import { isIterable } from '../util';
import { TransformWithLVS } from './TransformWithLVS';
export function ToArray(options = {}, transformOptions) {
    const { ignoreNull = false, ignoreUndefined = false } = options;
    return TransformWithLVS(({ value }) => {
        if (undefined === value) {
            return ignoreUndefined ? undefined : [];
        }
        if (value === null) {
            return ignoreNull ? null : [];
        }
        if (Array.isArray(value)) {
            return value;
        }
        if (typeof value === 'string') {
            return [value];
        }
        if (isIterable(value)) {
            return [...value];
        }
        return [value];
    }, transformOptions);
}
//# sourceMappingURL=ToArray.js.map